import { ProLayoutProps } from '@ant-design/pro-components';

const Settings: ProLayoutProps = {
  navTheme: 'light',
  layout: 'mix',
  contentWidth: 'Fixed',
  fixedHeader: true,
  fixSiderbar: true,
  splitMenus: false,
  colorWeak: false,
  siderMenuType: 'group',
  colorPrimary: '#FD6600',
  menu: { collapsedShowGroupTitle: false },
  pageTitleRender: false,
  suppressSiderWhenMenuEmpty: false,
  disableMobile: true,
  token: {
    bgLayout: '#F2F5F9',
    header: {
      colorBgHeader: '#fff',
      heightLayoutHeader: 56,
      colorTextMenu: '#333',
      colorTextMenuSecondary: '#333',
      colorTextMenuSelected: '#FD6600',
      colorTextRightActionsItem: '#dfdfdf',
      colorBgMenuItemHover: 'transparent',
      colorTextMenuActive: '#FD6600',
    },
    sider: {
      colorTextMenu: '#666',
      colorMenuBackground: '#fff',
      colorTextMenuSelected: '#FD6600',
      colorBgMenuItemSelected: '#f1f6fd',
    },
    pageContainer: {
      paddingBlockPageContainerContent: 16,
      paddingInlinePageContainerContent: 16,
    },
  },
  contentStyle: {
    padding: 0,
  },
};

export default Settings;
